import { useState } from 'react';

type Props = {
  visible?: boolean;
};

const useLazy = (props?: Props) => {
  const { visible: vis = false } = props || {};
  const [visible, setVisible] = useState<boolean>(vis);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [params, setParams] = useState<ObjectType>({});
  const show = (type, isClosable, options) => {
    setLoaded(true);
    setParams({
      type,
      isClosable,
      options
    });
    if (!loaded) {
      setTimeout(() => {
        setVisible(true);
      }, 30);
    } else {
      setVisible(true);
    }
  };
  const hide = () => {
    setVisible(false);
  };

  return {
    show,
    hide,
    visible,
    loaded,
    params
  };
};

export default useLazy;
